import React from 'react';
import { Picture, Source, Img } from '@xo-union/tk-component-picture';
import { isMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class GalleryHeroImage extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      custom_screen: isMobile ? 'mobile' : 'desktop'
    }
  }

  static defaultProps = {
    isMobile: false,
    infos: '',
    headline: '',
    page_sub_title: ''
  };

  onWindowResize() {
    this.setState({
      custom_screen: isMobile() ? 'mobile' : 'desktop'
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  render() {
    const { infos, headline, page_sub_title } = this.props;
    const { custom_screen } = this.state;

    const mobile_img_id = infos['mobile']['img_id']
    const desktop_img_id = infos['desktop']['img_id']
    const logo_img_id = custom_screen == 'mobile' ? infos['mobile']['logo_img_id'] : infos['desktop']['logo_img_id']
    const image_ratio = custom_screen == 'mobile' ? '57.6%' : '23.73%'

    return (
      <div className={styles['hero-image-section']} style={{height: 0, paddingBottom: image_ratio}}>
        <Picture pixelDensities={[1,2]}>
          <Source viewport="lg" width={1280} id={desktop_img_id} />
          <Source viewport="md" width={768} id={desktop_img_id} />
          <Source viewport="xs" width={480} id={mobile_img_id} />

          <Img className={styles["main-img"]} id={mobile_img_id} width={768} alt={infos.alt_text} />
        </Picture>
        <div className={styles["grey"]}></div>
        <div className={styles['designer-info']}>
          <h1 className={styles['headline']}>{headline}</h1>
          <h2 className={styles['page_sub_title']}>{page_sub_title}</h2>
          <span className={styles["designer-logo"]}>
            <Picture id={logo_img_id} pixelDensities={[1,2]}>
              <Source viewport="sm" width={110} />
              <Source viewport="md" width={380} />

              <Img className={styles["logo-img"]} width={380} alt={infos.logo_alt_text} />
            </Picture>
          </span>
        </div>
      </div>
    )
  }
}
